module.exports = __webpack_public_path__ + "media/hero_mv.cfc2c301.ogg";